import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

export default function Copyright() {
  const { t } = useTranslation();
  return (
    <Row gutter={[24, 48]}>
      <Col xs={24} lg={24}>
        <div className="footer-copyright">
          <img src="/images/apple-touch-icon.png" alt="Tenis.io Logo" width={24} height={24} loading="lazy" />
          Tenis.io {new Date().getFullYear()} | {t('copyright.text')}
        </div>
      </Col>
    </Row>
  );
}
